import React from 'react';
import { Link } from 'react-router-dom';
import { micahPortraitMain } from '../../data/products';
import './ArtistStory.css';

const ArtistStory: React.FC = () => (
  <section className="artist-story" aria-label="Artist story">
    <div className="artist-story__inner container">
      <div className="artist-story__image-col">
        <img
          src={micahPortraitMain}
          alt="Micah Lynise, multidisciplinary artist"
          className="artist-story__image"
          width={560}
          height={640}
          loading="lazy"
        />
      </div>

      <div className="artist-story__copy-col">
        <p className="artist-story__eyebrow">Created across mediums</p>
        <h2 className="artist-story__heading">
          Painting, music, and scent all give me different ways to create a world of my own and allow me to feel strongly.
        </h2>
        <p className="artist-story__body">
          I am an Austin-based painter, musician, and maker. Much of what I create has grown from a desire to build something meaningful from the grief that has shaped my life, particularly through my experiences with my mother and twin. Creating became a way for me to keep experimenting, growing, and remaining open to the world rather than shrinking inward.
        </p>
        <p className="artist-story__body">
          I began as an acrylic and oil painter, and over time I became interested in how art could move beyond the wall and become part of everyday life. That curiosity led me to bring my paintings into handmade body care and fragrance, adapting my original artwork into labels for body butters, body oils, and oil fragrances that I formulate and make myself.
        </p>
        <p className="artist-story__body">
          Painting, music, and scent all give me different ways to create a world of my own and make someone feel something. The scent I wear can shape how I move through a day—whether I want to feel luxurious, soft, grounded, or strong. Pairing each scent with artwork allows the visual world of the painting to reinforce that feeling, giving each product its own atmosphere and identity.
        </p>
        <p className="artist-story__body">
          Music has become another extension of that same impulse. I write and perform original music, creating from many of the same emotions, memories, and observations that find their way into my paintings and fragrances.
        </p>
        <p className="artist-story__body">
          Although these pursuits take different forms, they come from the same place: curiosity, feeling, and a desire to keep making something new. They have also given me a way to connect with people. Some of the most meaningful parts of this journey have come through conversations with customers, listeners, artists, musicians, fellow makers, and small business owners.
        </p>
        <p className="artist-story__body">
          For me, creating is a way of building beyond grief. It is a way to continue exploring, experimenting, and making a life that feels expansive, and to invite other people into the worlds I create along the way.
        </p>
        <Link to="/about" className="artist-story__cta">
          Our Story →
        </Link>
      </div>
    </div>
  </section>
);

export default ArtistStory;
